export const officeInitialState = [
  //{
  //  id: 1,
  //  name: "Electrical Department",
  //  type: "department",
  //  position_id: 1,
  //},
  //{
  //  id: 2,
  //  name: "Software Department",
  //  type: "department",
  //  position_id: 1,
  //},
  //{
  //  id: 3,
  //  name: "PG Office",
  //  type: "office",
  //  position_id: 1,
  //},
];
